module.exports = __webpack_public_path__ + "assets/icon-expand-component.2ada85db.svg";